export const CHAPTER_VERSION_CONFLICT = 'CHAPTER_VERSION_CONFLICT'
